const ticket = {
  event_required: 'Le billet doit être associé à un évènement',
  product_required: 'Un produit est requis',
  contact_required: 'Un contact est requis',
  status_required: 'Un statut est requis',
  status_invalid: 'Statut du billet invalide',
  identifier_required: 'Un numéro de billet est requis pour ce produit',
  sold_price_negative: 'Le prix de vente ne peut pas être négatif',
  email_invalid: 'Doit être une adresse courriel valide',
  save_error: 'Erreur lors de l\'enregistrement du billet',
};

export default ticket;
